var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.name === 'trailer')?_c('div',{staticClass:"videos"},_vm._l((_vm.films),function(film,index){return (_vm.$route.params.filmID === film.slug)?_c('video-player',{key:index,staticClass:"video-player",attrs:{"videoSRC":film.acf.video}}):_vm._e()}),1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-676e0ddb","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=jade!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/videos.vue
// module id = 140
// module chunks = 1